import {useSelector} from "react-redux";


const useMedicalRecordList = () => {
	const {medicalRecords} = useSelector((state) => state.patient);
	return {
		medicalRecords
	};
};
export default useMedicalRecordList;